<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <form class="forms-sample" ref="anyName" @submit.stop.prevent="onSubmit" autocomplete="off">
            <div class="row mt-5">
                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                    <div class="row flex-grow">
                        <div class="col-12 grid-margin">

                            <div class="card">
                                <div class="card-header">
                                    <h4 class="card-title">Member Transaction</h4>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6 col-sm-6">
                                            <b-form-group label="Member" label-for="UserID">
                                                <b-form-select name="UserID" v-model="form.UserID"
                                                    :options="MemberByOptions" class="mb-3" value-field="item"
                                                    text-field="name" @change="fetchRefundTransactions">
                                                    <!-- text-field="name" > -->
                                                </b-form-select>
                                            </b-form-group>
                                            <b-form-group label="Service Type" label-for="ServiceType">
                                                <b-form-select name="ServiceType" v-model="form.ServiceType"
                                                    :options="ServiceByOptions" class="mb-3" value-field="item"
                                                    text-field="name" @change="updateTransactionAmount('ServiceType')">
                                                </b-form-select>
                                            </b-form-group>
                                            <b-form-group label="Transaction Amount" label-for="TotalPayment">
                                                <b-form-input type="text" id="TotalPayment" name="TotalPayment"
                                                    autocomplete="TotalPayment" placeholder="Transaction Amount"
                                                    v-model="form.TotalPayment" 
                                                    :state="$v.form.TotalPayment.$dirty ? !$v.form.TotalPayment.$error : null">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                            <b-form-group id="TransactionDate" label="Transaction Date"
                                                label-for="TransactionDate">
                                                <b-form-input id="TransactionDate" type="date"
                                                    v-model="form.TransactionDate"></b-form-input>
                                            </b-form-group>
                                            <b-form-group id="billingDate" label="Recurring Billing Date"
                                                label-for="billingDate">
                                                <b-form-input id="billingDate" type="date"
                                                    v-model="form.billingDate"></b-form-input>
                                            </b-form-group>
                                            <b-form-group>
                                                <div class="checkboxes row" style="flex-wrap: nowrap">
                                                    <div class="checkbox-field col-md-4 col-sm-4">
                                                        <label>
                                                            Charge
                                                            <input type="checkbox" v-model="showCharge" @change="handleCheckboxChange" :disabled="showRefund">
                                                        </label>
                                                    </div>
                                                    <div class="checkbox-field col-md-4 col-sm-4">
                                                        <label>
                                                            Refund
                                                            <input type="checkbox" v-model="showRefund" @change="handleCheckboxChange" :disabled="showCharge">
                                                        </label>
                                                    </div>
                                                </div>
                                            </b-form-group>

                                            <b-form-group label="Refund Transaction" label-for="x_refTransId" v-if="showRefund">
                                                <b-form-select name="x_refTransId" v-model="form.x_refTransId"
                                                    :options="RefundTransactionOptions" class="mb-3" value-field="item" 
                                                    text-field="name" @change="updateRefundTransaction">
                                                </b-form-select>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6 col-sm-6 transaction-textarea">
                                            <b-form-group label="Notes:" label-for="Notes">
                                                <b-form-textarea id="Notes" v-model="form.Notes"
                                                    placeholder="Enter something..." rows="3" max-rows="6"
                                                    :state="$v.form.Notes.$dirty ? !$v.form.Notes.$error : null">
                                                </b-form-textarea>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6"></div>
                                        <div class="col-md-6 mt-3">
                                            <b-button type="submit" variant="success" :disabled="isDisabled"
                                                class="btn float-right btn-success">
                                                <span v-if="!this.form.id">Submit</span>
                                                <span v-if="this.form.id">Update</span>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";
import moment from 'moment'

export default {
    name: 'Users',
    mixins: [validationMixin],
    data() {
        return {
            ServiceByOptions: [],
            RefundTransactionOptions: [{ item: 0, name: '---Select Transaction---' }],
            MemberByOptions: [],
            form: {
                id: '',
                UserID: "1",
                Notes: '',
                ServiceType: 1,
                TotalPayment: '',
                TransactionDate: '',
                billingDate: '',
                x_refTransId: '0',
            },
            isDisabled: false,
            showCharge: false,
            showRefund: false,
            readonly: true,
            member: {},
        };
    },
    validations: {
        form: {
            Notes: {
                required,
            },
            ServiceType: {
                required,
            },
            TotalPayment: {
                required,
            },
            TransactionDate: {
                required,
            },
        }
    },
    mounted() {
        this.form.id = this.$route.params.id;
        if (this.form.id && this.form.id !== 'undefined') {
            this.readonly = true;
            this.getMember();
        } else {
            this.readonly = false;
        }
        this.getServicedropd();
        this.getPositions();
        this.getStates();
        this.getMemberships();
        this.getMemberdropd()
    },
    methods: {
        onSubmit() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.isDisabled = true;
            API.addTransaction(this.form,
                data => {
                    this.isDisabled = false;
                    if (!this.form.id) {
                        if (data.status === 410) {
                            this.$showNotification(data, "error") 
                        } else {
                            this.$showNotification(data, "success")
                            this.submitForm();
                        }
                    } else {
                        if (data.status === 200) {
                            this.$showNotification(data, "success")
                            this.submitForm();
                        } else {
                            this.$showNotification({ message: 'Please try again.' }, "error")
                        }
                    }
                },
                err => {
                    this.isDisabled = false;
                    console.log(err);
                    this.$showNotification({ message: 'Failed system error' }, "error")
                }
            )
        },
        submitForm() {
            this.$refs.anyName.reset();
        },
        getMember() {
            API.getMember(this.form.id,
                data => {
                    this.form.ReferralDate = data.data.ReferralDate;
                    this.form.MemberSince = data.data.MemberSince;
                    this.form.MembershipDate = data.data.MembershipDate;
                },
                err => {
                }
            )
        },
        getMemberdropd() {
            API.getMemberdropd(
                data => {
                    data.forEach((user) => {
                        this.MemberByOptions.push({
                            item: user.UserID,
                            name: user.FirstName + ' ' + user.LastName,
                        });
                    });
                }, err => {
                })
        },
        getServicedropd() {
            API.getServicedropd(
                data => {
                    data.forEach((user) => {
                        this.ServiceByOptions.push({
                            item: user.ServiceID,
                            name: user.ServiceName,
                            cost: user.Cost,
                        });
                    });
                }, err => {
            })
        },
        formatDate(value, event) {
            if (value) {
                return moment(value).format('MMM dd, yyyy')
            }
        },
        getPositions() {
            API.getPositions(
                data => {
                    data.forEach((position) => {
                        this.StatusOptions.push({
                            item: position.status,
                            name: position.status,
                        });
                    });
                }, err => {
                })
        },
        getStates() {
            API.getStates(
                data => {
                    data.forEach((state) => {
                        this.StateOptions.push({
                            item: state.StateID,
                            name: state.Name,
                        });
                    });
                }, err => {
                })
        },
        getMemberships() {
            API.getMemberships(
                data => {
                    data.forEach((membership) => {
                        this.membershipOptions.push({
                            item: membership.MembershipID,
                            name: membership.membership,
                        });
                    });
                }, err => {
                })
        },
        handleCheckboxChange() {
            // Disable opposite checkbox based on the user's selection
            if (this.showCharge) {
                this.showRefund = false;
            } else if (this.showRefund) {
                this.showCharge = false;
            }
        },
        fetchRefundTransactions() {
            API.getRefundTransactions(this.form.UserID, (data) => {
                this.RefundTransactionOptions = data.map(transaction => ({
                    item: transaction.PaymentID,
                    name: transaction.ServiceName + ' ' + '(' + moment(String(transaction.PaymentDate)).format('MMM dd, yyyy')+ ') - $' + transaction.TotalPayment, 
                    ServiceID: transaction.ServiceID,
                    TotalPayment: transaction.TotalPayment,
                }));
                
                // Auto-select the first refund transaction
                if (this.RefundTransactionOptions.length > 0) {
                    this.form.x_refTransId = this.RefundTransactionOptions[0].item;
                    this.updateRefundTransaction();
                }else {
                    this.RefundTransactionOptions = [{ item: 0, name: '---Select Transaction---' }];
                }
            }, (err) => {
                console.error('Error fetching refund transactions:', err);
                this.RefundTransactionOptions = [{ item: 0, name: '---Select Transaction---' }];
            });
        },
        updateRefundTransaction() {
            const selectedRefundTransaction = this.RefundTransactionOptions.find(transaction => transaction.item == this.form.x_refTransId);
            if (selectedRefundTransaction) {
                // Update TotalPayment based on the selected refund transaction
                this.form.TotalPayment = parseFloat(selectedRefundTransaction.TotalPayment).toFixed(2);

                // Auto-select ServiceType based on the selected refund transaction
                const correspondingService = this.ServiceByOptions.find(service => service.item == selectedRefundTransaction.ServiceID);
                if (correspondingService) {
                    this.form.ServiceType = correspondingService.item;
                }
            } else {
                // Reset TotalPayment and ServiceType if no refund transaction is selected
                this.form.TotalPayment = '';
                this.form.ServiceType = 0;
            }
        },

        updateTransactionAmount(field) {
            const selectedService = this.ServiceByOptions.find(service => service.item === this.form[field]);
            if (selectedService) {
                this.form.TotalPayment = parseFloat(selectedService.cost).toFixed(2); // Assuming 'cost' is the property from the services table
            } else {
                this.form.TotalPayment = ''; // Reset to empty if no service is selected
            }
        },
    }, computed: {},
}
</script>
